export default "__VITE_ASSET__TBBRuos1__"